interface NydusNetworkDataErrorConstructor {
  httpMethod: 'GET' | 'POST' | 'PUT' | 'DELETE';
  endpoint: string;
  message: string;
}

export class NydusNetworkDataError {
  httpMethod: string;
  endpoint: string;
  message: string;

  constructor(params: NydusNetworkDataErrorConstructor) {
    this.httpMethod = params.httpMethod;
    this.endpoint = params.endpoint;
    this.message = params.message;
  }

  toString(): string {
    return `NydusNetworkDataError: ${this.httpMethod} on ${this.endpoint}: ${this.message}`;
  }
}
